import React from 'react';

const UploadCloudIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none" {...rest}>
      <g clipPath="url(#clip0_1061_15482)">
        <path d="M18.6669 18.6667L14.0002 14.0001M14.0002 14.0001L9.33353 18.6667M14.0002 14.0001V24.5001M23.7885 21.4551C24.9264 20.8347 25.8253 19.8531 26.3434 18.6651C26.8614 17.4772 26.9691 16.1505 26.6494 14.8945C26.3298 13.6386 25.6009 12.5248 24.578 11.7291C23.555 10.9333 22.2962 10.5009 21.0002 10.5001H19.5302C19.1771 9.13418 18.5189 7.86612 17.6051 6.79122C16.6914 5.71632 15.5459 4.86255 14.2546 4.2941C12.9634 3.72565 11.5602 3.45731 10.1503 3.50926C8.7405 3.5612 7.36078 3.93208 6.1149 4.59401C4.86903 5.25593 3.78943 6.19168 2.95726 7.33091C2.12509 8.47013 1.562 9.78319 1.31034 11.1714C1.05868 12.5595 1.12499 13.9867 1.50428 15.3455C1.88357 16.7044 2.56598 17.9596 3.5002 19.0167" stroke="#6D7885" strokeWidth="2.33333" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1061_15482">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UploadCloudIcon;